import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Dc3Topic, Topic } from '../../../data/topic/topic';
import { Tables } from '../../../data/database.types';

@Component({
  selector: 'app-topic-block',
  templateUrl: './topic-block.component.html',
  styleUrls: ['./topic-block.component.scss']
})
export class TopicBlockComponent implements OnInit {
  @Input() icon?: string;
  @Input() header?: string;

  @Input() topics: Topic[] | undefined | null;
  @Input() topicButton = false;
  @Input() selectedTopicIds: number[] | undefined | null;

  @Output() topicClick = new EventEmitter<Topic>();

  constructor() {
  }

  ngOnInit() {
  }

}
